// deps
import Router from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router";
import Uri from "@splitfire-agency/raiden-library/dist/libraries/Uri";

const apiRouter = new Router();

apiRouter.group(
  new Uri(
    // @ts-ignore
    process.env.NEXT_PUBLIC_API_SCHEME,
    null,
    process.env.NEXT_PUBLIC_API_HOST,
    null,
    process.env.NEXT_PUBLIC_API_BASE_PATH,
    null,
    null,
  ),
  function (apiRouter) {
    apiRouter.group("/api", function (apiRouter) {
      // Configuration
      apiRouter.get("/configuration").setId("@configuration");
      apiRouter.get("/translation").setId("@api.translation");

      // Environments
      apiRouter.group("/environments", function (apiRouter) {
        apiRouter.get("").setId("@environments.search");
        apiRouter.post("").setId("@environments.create");
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.post("/merge").setId("@environments.merge");
        });

        apiRouter.group("/<environmentId>", function (apiRouter) {
          apiRouter.setConstraint("environmentId", /\d+/);
          apiRouter.get("/quotas").setId("@environments.quotas");
          apiRouter.get("").setId("@environments.view");
          apiRouter.get("").setId("@environments.quotas");
          apiRouter.post("").setId("@environments.update");
          apiRouter.post("").setId("@environments.updateRecordsAccounts");
          apiRouter.post("").setId("@environments.updateDepartments");
          apiRouter.post("").setId("@environments.softDelete");
          apiRouter.post("").setId("@environments.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@environments.restore");
            apiRouter
              .post("/attach-department")
              .setId("@environments.attachDepartment");
          });
        });
      });

      // Amenities
      apiRouter.group("/amenities", function (apiRouter) {
        apiRouter.get("").setId("@amenities.search");
        apiRouter.post("").setId("@amenities.create");

        apiRouter.group("/<id>", function (apiRouter) {
          apiRouter.setConstraint("id", /\d+/);
          apiRouter.get("").setId("@amenities.view");
          apiRouter.post("").setId("@amenities.update");
          apiRouter.post("").setId("@amenities.softDelete");
          apiRouter.post("").setId("@amenities.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/autocomplete").setId("@amenities.autocomplete");
            apiRouter.post("/restore").setId("@amenities.restore");
            apiRouter.get("/dictionary").setId("@amenities.dictionary");
          });
        });
      });

      // Black list contacts
      apiRouter.group("/blacklist-contacts", function (apiRouter) {
        apiRouter.get("").setId("@blacklistContacts.viewAny");
        apiRouter.post("").setId("@blacklistContacts.create");

        apiRouter.group("/<blackListContactId>", function (apiRouter) {
          apiRouter.setConstraint("blackListContactId", /\d+/);
          apiRouter.delete("").setId("@blacklistContacts.softDelete");
          apiRouter.delete("").setId("@blacklistContacts.delete");

          apiRouter.post("").setId("@blacklistContacts.update");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@blacklistContacts.restore");
            apiRouter.post("/verify").setId("@blacklistContacts.verify");
          });
        });
      });

      // Compositions
      apiRouter.group("/compositions", function (apiRouter) {
        apiRouter.get("").setId("@compositions.search");
        apiRouter.post("").setId("@compositions.create");

        apiRouter.group("/<id>", function (apiRouter) {
          apiRouter.setConstraint("id", /\d+/);
          apiRouter.get("").setId("@compositions.view");
          apiRouter.post("").setId("@compositions.update");
          apiRouter.post("").setId("@compositions.softDelete");
          apiRouter.post("").setId("@compositions.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/autocomplete").setId("@compositions.autocomplete");
            apiRouter.post("/restore").setId("@compositions.restore");
          });
        });
      });

      // Departements
      apiRouter.group("/departments", function (apiRouter) {
        apiRouter.get("/<departmentId>").setId("@departments.view");
        apiRouter.get("").setId("@departments.viewAny");
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.get("/autocomplete").setId("@departments.autocomplete");
        });
        apiRouter.group("/<departmentId>", function (apiRouter) {
          apiRouter.setConstraint("departmentId", /\d+/);
          apiRouter.get("").setId("@departments.view");
          apiRouter.post("").setId("@departments.update");
        });
      });

      // Régions
      apiRouter.group("/regions", function (apiRouter) {
        apiRouter.get("").setId("@regions.viewAny");
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.get("/autocomplete").setId("@regions.autocomplete");
        });

        apiRouter.group("/<regionId>", function (apiRouter) {
          apiRouter.setConstraint("regionId", /\d+/);
          apiRouter.get("").setId("@regions.view");
          apiRouter.post("").setId("@regions.update");
        });
      });

      // Anciennes régions
      apiRouter.group("/legacy-regions", function (apiRouter) {
        apiRouter.get("").setId("@legacyRegions.viewAny");
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.get("/autocomplete").setId("@legacyRegions.autocomplete");
        });

        apiRouter.group("/<regionId>", function (apiRouter) {
          apiRouter.setConstraint("regionId", /\d+/);
          apiRouter.get("").setId("@legacyRegions.view");
          apiRouter.post("").setId("@legacyRegions.update");
        });
      });

      // Redirections urls
      apiRouter.group("/redirections/urls", function (apiRouter) {
        apiRouter.get("").setId("@api.redirections.urls.viewAny");
        apiRouter.post("").setId("@api.redirections.urls.create");

        apiRouter.group("/action", function (apiRouter) {
          apiRouter.post("/hit").setId("@api.redirections.urls.hit");
        });

        apiRouter.group("/<redirectionUrlId>", function (apiRouter) {
          apiRouter.setConstraint("redirectionUrlId", /\d+/);
          apiRouter.get("").setId("@api.redirections.urls.view");
          apiRouter.post("").setId("@api.redirections.urls.update");
          apiRouter.post("").setId("@api.redirections.urls.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@api.redirections.urls.restore");
          });
        });
      });

      // Cities
      apiRouter.group("/cities", function (apiRouter) {
        apiRouter.get("").setId("@cities.viewAny");
        apiRouter.post("").setId("@cities.create");
        apiRouter.group("/<cityId>", function (apiRouter) {
          apiRouter.setConstraint("cityId", /\d+/);
          apiRouter.get("").setId("@cities.view");
          apiRouter.post("").setId("@cities.update");
          apiRouter.post("").setId("@cities.softDelete");
          apiRouter.post("").setId("@cities.delete");
          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@cities.restore");
          });
        });
      });

      // Users
      apiRouter.group("/users", function (apiRouter) {
        // Users/Groups
        apiRouter.group("/groups", function (apiRouter) {
          apiRouter.get("").setId("@usersGroups.search");

          apiRouter.post("").setId("@usersGroups.create");
          apiRouter.group("/action", function (apiRouter) {
            apiRouter.get("/autocomplete").setId("@usersGroups.autocomplete");
          });

          apiRouter.group("/<usersGroupId>", function (apiRouter) {
            apiRouter.setConstraint("usersGroupId", /\d+/);

            apiRouter.get("").setId("@usersGroups.show");

            apiRouter.post("").setId("@usersGroups.edit");

            apiRouter.delete("").setId("@usersGroups.delete");
          });
        });

        // Users/Admins
        apiRouter.group("/admins", function (apiRouter) {
          apiRouter.get("").setId("@usersAdmins.search");

          apiRouter.post("").setId("@usersAdmins.create");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.group("/autocomplete", function (apiRouter) {
              apiRouter.get("").setId("@usersAdmins.autocomplete");
            });

            apiRouter.group("/dashboard", function (apiRouter) {
              apiRouter.get("").setId("@usersAdmins.dashboard");
            });
          });

          apiRouter.group("/<usersAdminId>", function (apiRouter) {
            apiRouter.setConstraint("usersAdminId", /\d+/);

            apiRouter.get("").setId("@usersAdmins.show");

            apiRouter.post("").setId("@usersAdmins.edit");

            apiRouter.delete("").setId("@usersAdmins.delete");
          });
        });

        // Users/PasswordResets
        apiRouter.group("/password-resets", function (apiRouter) {
          apiRouter.post("").setId("@usersPasswordResets.create");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter
              .post("/finish")
              .setId("@usersPasswordResets.actionFinish");
          });
        });

        // Users/Customers
        apiRouter.group("/customers", (apiRouter) => {
          apiRouter.get("").setId("@customers.viewAny");
          apiRouter.post("").setId("@customers.create");

          apiRouter.group("/<customerId>", function (apiRouter) {
            apiRouter.setConstraint("customerId", /\d+/);

            apiRouter.delete("").setId("@customers.delete");
            apiRouter.get("").setId("@customers.view");
            apiRouter.post("").setId("@customers.update");

            apiRouter.group("/action", function (apiRouter) {
              apiRouter
                .post("/notify-verification-email")
                .setId("@customers.notifyEmailVerification");

              apiRouter.post("/restore").setId("@customers.restore");

              apiRouter.post("/verify-email").setId("@customers.verifyEmail");

              apiRouter.get("/public-phone").setId("@customers.publicPhone");
            });
          });
          apiRouter.group("/action", function (apiRouter) {
            apiRouter
              .get("/email-availability")
              .setId("@customers.emailAvailability");
            apiRouter.get("/dashboard").setId("@customers.dashboard");

            apiRouter.group("/autocomplete", function (apiRouter) {
              apiRouter.get("").setId("@customers.autocomplete");
            });

            apiRouter.group("/export", function (apiRouter) {
              apiRouter.get("").setId("@customers.export");
            });
          });
        });

        //users/bank-accouts
        apiRouter.group("/bank-accounts", (apiRouter) => {
          apiRouter.get("").setId("@bankAccounts.viewAny");
          apiRouter.post("").setId("@bankAccounts.create");
          apiRouter.group("/<bankAccountId>", function (apiRouter) {
            apiRouter.setConstraint("bankAccountId", /\d+/);
            apiRouter.delete("").setId("@bankAccounts.delete");
            apiRouter.post("").setId("@bankAccounts.update");
            apiRouter.group("/action", function (apiRouter) {
              apiRouter
                .get("/autocomplete")
                .setId("@bankAccounts.autocomplete");

              apiRouter.group("/cancel", function (apiRouter) {
                apiRouter.get("").setId("@bankAccounts.cancel");
              });
              apiRouter.group("/restore", function (apiRouter) {
                apiRouter.get("").setId("@bankAccounts.restore");
              });
            });
          });
        });

        // Users/Customers/Contacts
        apiRouter.group("/contacts", function (apiRouter) {
          apiRouter.group("/<contactId>", function (apiRouter) {
            apiRouter.group("/action", function (apiRouter) {
              apiRouter.post("/initialize").setId("@usersContacts.initialize");
              apiRouter.post("/verify").setId("@usersContacts.verify");
            });
          });
        });

        apiRouter.group("/notification-preferences", function (apiRouter) {
          apiRouter.post("").setId("@usersNotificationsPreferences.update");
        });

        // Users/2FA
        apiRouter.group("/two-factor-authentication", function (apiRouter) {
          apiRouter.get("").setId("@2fa.view");
          apiRouter.delete("").setId("@2fa.delete");
          apiRouter.post("").setId("@2fa.enable");
          apiRouter.post("/enrollment").setId("@2fa.enrollment");
          apiRouter.post("/challenge").setId("@2fa.challenge");
        });
      });

      // Customers/Contacts
      apiRouter.group("/customers/contacts", (apiRouter) => {
        apiRouter.get("").setId("@customers.contacts.viewAny");
        apiRouter.post("").setId("@customers.contacts.create");

        apiRouter.group("/<customerContactId>", (apiRouter) => {
          apiRouter.setConstraint("customerContactId", /\d+/);
          apiRouter.get("").setId("@customers.contacts.view");
          apiRouter.post("").setId("@customers.contacts.update");
          apiRouter.delete("").setId("@customers.contacts.delete");

          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/restore").setId("@customers.contacts.restore");
          });
        });

        // Customers/Contacts/Categories
        apiRouter.group("/categories", (apiRouter) => {
          apiRouter.get("").setId("@customers.contacts.categories.viewAny");
          apiRouter.post("").setId("@customers.contacts.categories.create");

          apiRouter.group("/<customerContactCategoryId>", (apiRouter) => {
            apiRouter.setConstraint("customerContactCategoryId", /\d+/);
            apiRouter.get("").setId("@customers.contacts.categories.view");
            apiRouter.post("").setId("@customers.contacts.categories.update");
            apiRouter.delete("").setId("@customers.contacts.categories.delete");

            apiRouter.group("/action", (apiRouter) => {
              apiRouter
                .post("/restore")
                .setId("@customers.contacts.categories.restore");
            });
          });

          // Customers/Contacts/Categories/CustomAttributes
          apiRouter.group("/custom-attributes", (apiRouter) => {
            apiRouter
              .get("")
              .setId(
                "@customers.contacts.categories.custom_attributes.viewAny",
              );
            apiRouter
              .post("")
              .setId("@customers.contacts.categories.custom_attributes.create");

            apiRouter.group(
              "/<customerContactCategoryCustomAttributeId>",
              (apiRouter) => {
                apiRouter.setConstraint(
                  "customerContactCategoryCustomAttributeId",
                  /\d+/,
                );
                apiRouter
                  .get("")
                  .setId(
                    "@customers.contacts.categories.custom_attributes.view",
                  );
                apiRouter
                  .post("")
                  .setId(
                    "@customers.contacts.categories.custom_attributes.update",
                  );
                apiRouter
                  .delete("")
                  .setId(
                    "@customers.contacts.categories.custom_attributes.delete",
                  );

                apiRouter.group("/action", (apiRouter) => {
                  apiRouter
                    .post("/restore")
                    .setId(
                      "@customers.contacts.categories.custom_attributes.restore",
                    );
                });
              },
            );
          });
        });
      });

      // Customers/Travelers
      apiRouter.group("/customers", (apiRouter) => {
        apiRouter.group("/travelers", (apiRouter) => {
          apiRouter.get("").setId("@customersTravelers.viewAny");
          apiRouter.post("").setId("@customersTravelers.create");

          apiRouter.post("/export").setId("@customersTravelers.export");

          apiRouter.group("/<travelerId>", function (apiRouter) {
            apiRouter.setConstraint("travelerId", /\d+/);
            apiRouter.get("").setId("@customersTravelers.view");
            apiRouter.post("").setId("@customersTravelers.update");
            apiRouter.delete("").setId("@customersTravelers.delete");
          });
        });
      });

      // signatures
      apiRouter.group("/signatures", function (apiRouter) {
        apiRouter.group("/<signatureId>", function (apiRouter) {
          apiRouter.setConstraint("signatureId", /\d+/);

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.group("/download", function (apiRouter) {
              apiRouter.get("").setId("@signatures.download");
            });
            apiRouter.group("/download-audit-trail", function (apiRouter) {
              apiRouter.get("").setId("@signatures.downloadAuditTrail");
            });
          });
        });
      });

      // Posts
      apiRouter.group("/posts", function (apiRouter) {
        apiRouter.get("").setId("@posts.viewAny");

        apiRouter.post("").setId("@posts.create");

        apiRouter.group("/<postId>", function (apiRouter) {
          apiRouter.setConstraint("postId", /\d+/);

          apiRouter.get("").setId("@posts.show");

          apiRouter.post("").setId("@posts.edit");

          apiRouter.delete("").setId("@posts.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@posts.restore");
          });
        });

        // Posts/Categories
        apiRouter.group("/categories", function (apiRouter) {
          apiRouter.get("").setId("@postsCategories.viewAny");

          apiRouter.get("/tree").setId("@postsCategories.treeView");

          apiRouter.post("/tree").setId("@postsCategories.treeUpdate");

          apiRouter.post("").setId("@postsCategories.create");

          apiRouter.group("/<postsCategoryId>", function (apiRouter) {
            apiRouter.setConstraint("postsCategoryId", /\d+/);

            apiRouter.get("").setId("@postsCategories.show");

            apiRouter.post("").setId("@postsCategories.update");

            apiRouter.post("").setId("@postsCategories.delete");

            apiRouter.group("/action", function (apiRouter) {
              apiRouter.group("/restore", function (apiRouter) {
                apiRouter.post("").setId("@postsCategories.restore");
              });
            });
          });
        });

        apiRouter.group("/revisions", function (apiRouter) {
          apiRouter.group("/<postsRevisionId>", function (apiRouter) {
            apiRouter.setConstraint("postsRevisionId", /\d+/);

            apiRouter.post("").setId("@postsRevisions.update");

            apiRouter.delete("").setId("@postsRevisions.delete");

            apiRouter.group("/action", function (apiRouter) {
              apiRouter.post("/review").setId("@postsRevisions.review");

              apiRouter.post("/restore").setId("@postsRevisions.restore");
            });
          });
        });
      });

      // Covers
      apiRouter.group("/covers", function (apiRouter) {
        apiRouter.get("").setId("@covers.viewAny");

        apiRouter.post("").setId("@covers.create");

        apiRouter.group("/<coverId>", function (apiRouter) {
          apiRouter.setConstraint("coverId", /\d+/);

          apiRouter.post("").setId("@covers.edit");

          apiRouter.delete("").setId("@covers.delete");
        });

        apiRouter.group("/action", (apiRouter) => {
          apiRouter.post("/batch").setId("@covers.batch");
        });
      });

      // Files
      apiRouter.group("/files", function (apiRouter) {
        apiRouter.get("").setId("@files.viewAny");

        apiRouter.post("").setId("@files.create");

        apiRouter.group("/<fileId>", function (apiRouter) {
          apiRouter.setConstraint("fileId", /\d+/);

          apiRouter.delete("").setId("@files.delete");

          apiRouter.get("").setId("@files.view");

          apiRouter.post("").setId("@files.update");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@files.restore");
          });
        });
      });

      // Countries
      apiRouter.group("/countries", function (apiRouter) {
        apiRouter.get("").setId("@countries.search");
        apiRouter.post("").setId("@countries.create");

        apiRouter.group("/<countryId>", function (apiRouter) {
          apiRouter.setConstraint("countryId", /\d+/);
          apiRouter.get("").setId("@countries.show");
          apiRouter.post("").setId("@countries.edit");
          apiRouter.post("").setId("@countries.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@countries.restore");
          });
        });
      });

      // Menus
      apiRouter.group("/menus", function (apiRouter) {
        apiRouter.get("").setId("@menus.viewAny");
        apiRouter.post("").setId("@menus.create");

        apiRouter.group("/<menuId>", function (apiRouter) {
          apiRouter.setConstraint("menuId", /\d+/);
          apiRouter.get("").setId("@menus.view");
          apiRouter.post("").setId("@menus.update");
          apiRouter.delete("").setId("@menus.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@menus.restore");
          });
        });
      });

      // Authorizations
      apiRouter.group("/authorizations", function (apiRouter) {
        apiRouter.get("").setId("@authorizations.viewAny");
      });

      // Carts
      apiRouter.group("/carts", function (apiRouter) {
        apiRouter.post("").setId("@carts.create");

        apiRouter.group("/<cartId>", function (apiRouter) {
          apiRouter.setConstraint("cartId", /\d+/);

          apiRouter.get("").setId("@carts.show");

          apiRouter.group("/guests", function (apiRouter) {
            apiRouter.post("").setId("@cartsGuests.create");

            apiRouter.group("/<guestId>", function (apiRouter) {
              apiRouter.post("").setId("@cartsGuests.update");

              apiRouter.delete("").setId("@cartsGuests.delete");
            });
          });

          apiRouter.group("/payments", function (apiRouter) {
            apiRouter.post("").setId("@cartsPayments.create");

            apiRouter.group("/<paymentId>", function (apiRouter) {
              apiRouter.post("").setId("@cartsPayments.update");

              apiRouter.delete("").setId("@cartsPayments.delete");
            });
          });
        });

        apiRouter.group("/<cartId>", function (apiRouter) {
          apiRouter.setConstraint("cartId", /\d+/);
          apiRouter.group("/bookings", function (apiRouter) {
            apiRouter.post("").setId("@cartsBookings.create");

            apiRouter.group("/<bookingId>", function (apiRouter) {
              apiRouter.setConstraint("bookingId", /\d+/);

              apiRouter.get("").setId("@cartsBookings.show");

              apiRouter.delete("").setId("@cartsBookings.delete");

              apiRouter.post("").setId("@cartsBookings.update");

              apiRouter.post("/reviews").setId("@cartsBookingsReviews.create");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter.post("/cancel").setId("@cartsBookings.cancel");
                apiRouter
                  .post("/acknowledge")
                  .setId("@cartsBookings.acknowledge");

                apiRouter.get("/files").setId("@cartsBookings.filesDownload");

                apiRouter.post("/files").setId("@cartsBookings.filesSend");

                apiRouter
                  .post("/documents")
                  .setId("@cartsBookings.documentsSend");
              });

              // Carts bookings messages
              apiRouter.group("/messages", function (apiRouter) {
                apiRouter.get("").setId("@cartsBookingsMessages.viewAny");
                apiRouter.post("").setId("@cartsBookingsMessages.create");
              });

              // Carts bookings issues
              apiRouter.group("/issues", function (apiRouter) {
                apiRouter.post("").setId("@cartsBookingsIssues.create");

                apiRouter.group("/<issueId>", function (apiRouter) {
                  apiRouter.setConstraint("issueId", /\d+/);
                  apiRouter.get("").setId("@cartsBookingsIssues.show");
                  apiRouter.post("").setId("@cartsBookingsIssues.update");
                });
              });

              // Carts bookings deadlines
              apiRouter.group("/deadlines", function (apiRouter) {
                apiRouter.post("").setId("@cartsBookingsDeadlines.create");

                apiRouter.group("/<deadlineId>", function (apiRouter) {
                  apiRouter.setConstraint("deadlineId", /\d+/);

                  apiRouter.post("").setId("@cartsBookingsDeadlines.update");
                  apiRouter.delete("").setId("@cartsBookingsDeadlines.delete");

                  apiRouter.group("/action", function (apiRouter) {
                    apiRouter
                      .post("/sold")
                      .setId("@cartsBookingsDeadlines.sold");
                  });
                });
              });
            });
          });
        });

        apiRouter.group("/bookings", function (apiRouter) {
          apiRouter.get("").setId("@cartsBookings.viewAny");
          apiRouter.group("/messages", function (apiRouter) {
            apiRouter.group("/topics", function (apiRouter) {
              apiRouter.get("").setId("@cartsBookingsMessagesTopics.viewAny");
            });
          });

          apiRouter.group("/reviews", function (apiRouter) {
            apiRouter.get("").setId("@cartsBookingsReviews.viewAny");

            apiRouter.group("/<reviewId>", function (apiRouter) {
              apiRouter.get("").setId("@cartsBookingsReviews.show");

              apiRouter.post("").setId("@cartsBookingsReviews.update");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .post("/owner-moderation")
                  .setId("@cartsBookingsReviews.ownerModeration");

                apiRouter
                  .post("/update-owner")
                  .setId("@cartsBookingsReviews.updateOwner");

                apiRouter
                  .post("/admin-moderation")
                  .setId("@cartsBookingsReviews.adminModeration");
              });
            });
          });

          apiRouter.group("/<bookingId>", function (apiRouter) {
            apiRouter.setConstraint("bookingId", /\d+/);

            apiRouter.get("").setId("@cartsBookings.show");

            apiRouter.group("/issues", function (apiRouter) {
              apiRouter.post("").setId("@cartsBookingsIssues.create");
            });

            apiRouter.group("/reviews", function (apiRouter) {
              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .post("/request")
                  .setId("@cartsBookingsReviews.requestReview");
              });
            });
          });

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.group("/export", function (apiRouter) {
              apiRouter.get("").setId("@cartsBookings.export");
            });

            apiRouter.group("/estimate", function (apiRouter) {
              apiRouter.post("").setId("@cartsBookings.estimate");
            });
          });

          // Carts bookings issues for search
          apiRouter.group("/issues", function (apiRouter) {
            apiRouter.get("").setId("@cartsBookingsIssues.viewAny");
          });
        });
      });

      // accounts records
      apiRouter.group("/accounts", function (apiRouter) {
        apiRouter.group("/records", function (apiRouter) {
          apiRouter.group("/exports", function (apiRouter) {
            apiRouter.get("").setId("@accountsRecordsExports.viewAny");

            apiRouter.group("/<exportId>", function (apiRouter) {
              apiRouter.setConstraint("exportId", /\d+/);
              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .post("/download")
                  .setId("@accountsRecordsExports.download");
              });
            });
          });
        });
      });

      // Hotels
      apiRouter.group("/hotels", function (apiRouter) {
        apiRouter.get("").setId("@hotels.viewAny");

        apiRouter.post("").setId("@hotels.create");

        // View hotel contacts global (or with hotelId in GET parameter)
        apiRouter.get("/contacts").setId("@hotelsContacts.viewAny");

        apiRouter.group("/<hotelId>", function (apiRouter) {
          apiRouter.setConstraint("hotelId", /\d+/);
          apiRouter.get("").setId("@hotels.view");
          apiRouter.post("").setId("@hotels.update");
          apiRouter.delete("").setId("@hotels.delete");

          apiRouter.group("/contacts", function (apiRouter) {
            apiRouter.post("").setId("@hotelsContacts.create");

            apiRouter.group("/<hotelContactId>", function (apiRouter) {
              apiRouter.get("/").setId("@hotelsContacts.view");
              apiRouter.post("/").setId("@hotelsContacts.update");
              apiRouter.delete("/").setId("@hotelsContacts.delete");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter.post("/restore").setId("@hotelsContacts.restore");
              });
            });
          });

          apiRouter.group("/guests-contacts", function (apiRouter) {
            apiRouter.get("/").setId("@hotelsGuestsContacts.viewAny");
            apiRouter.post("/").setId("@hotelsGuestsContacts.create");

            apiRouter.group("/<hotelsGuestsContactsId>", function (apiRouter) {
              apiRouter.delete("/").setId("@hotelsGuestsContacts.delete");
              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .post("/restore")
                  .setId("@hotelsGuestsContacts.restore");
              });
            });
          });

          apiRouter.group("/rooms", function (apiRouter) {
            apiRouter.group("/pictures", function (apiRouter) {
              apiRouter.get("/").setId("@hotels.pictures.viewAny");
              apiRouter.post("/").setId("@hotels.pictures.create");

              apiRouter.group("/<pictureId>", function (apiRouter) {
                apiRouter.post("/").setId("@hotels.pictures.update");
                apiRouter.delete("/").setId("@hotels.pictures.delete");
              });
            });

            apiRouter.group("/availabilities", function (apiRouter) {
              apiRouter.get("/").setId("@hotels.rooms.availabilities");
              apiRouter
                .get("/batch")
                .setId("@hotels.rooms.availabilities.batch");

              apiRouter.group("/partners", function (apiRouter) {
                apiRouter
                  .get("")
                  .setId("@hotelsRoomsAvailabilitiesPartner.viewAny");

                apiRouter.group("/<partnerId>", function (apiRouter) {
                  apiRouter
                    .post("")
                    .setId("@hotelsRoomsAvailabilitiesPartner.update");
                  apiRouter
                    .delete("")
                    .setId("@hotelsRoomsAvailabilitiesPartner.delete");
                });
              });
            });
          });

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.get("/export").setId("@hotels.export");
            apiRouter.post("/restore").setId("@hotels.restore");

            apiRouter.group("/autocomplete", function (apiRouter) {
              apiRouter.get("").setId("@hotels.autocomplete");
            });
          });

          apiRouter.group("/rooms", (apiRouter) => {
            apiRouter.group("/compositions", (apiRouter) => {
              apiRouter.get("").setId("@hotelsRoomsCompositions.viewAny");
              apiRouter.post("").setId("@hotelsRoomsCompositions.create");

              apiRouter.group("/<roomCompositionId>", function (apiRouter) {
                apiRouter.setConstraint("roomCompositionId", /\d+/);
                apiRouter.post("").setId("@hotelsRoomsCompositions.update");
                apiRouter.post("").setId("@hotelsRoomsCompositions.view");
                apiRouter.delete("").setId("@hotelsRoomsCompositions.delete");
                apiRouter.post("").setId("@hotelsRoomsCompositions.view");
                apiRouter.group("/action", (apiRouter) => {
                  apiRouter
                    .post("/restore")
                    .setId("@hotelsRoomsCompositions.restore");
                });
              });
            });
          });

          apiRouter.group("/metrics", function (apiRouter) {
            apiRouter.post("/events").setId("@hotelsMetrics.create");
          });
        });

        apiRouter.group("/rooms", (apiRouter) => {
          apiRouter.post("").setId("@rooms.create");

          apiRouter
            .get("/availabilities")
            .setId("@hotelRoomsAvailabilities.show");

          apiRouter.group("/rankings", (apiRouter) => {
            apiRouter.get("").setId("@roomRankings.viewAny");

            apiRouter.group("/<rankingId>", function (apiRouter) {
              apiRouter.get("").setId("@roomRankings.view");
              apiRouter.delete("").setId("@roomRankings.delete");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter.post("/restore").setId("@roomRankings.restore");
              });
            });
          });

          apiRouter.group("/<roomId>", function (apiRouter) {
            apiRouter.setConstraint("hotelId", /\d+/);
            apiRouter.setConstraint("roomId", /\d+/);
            apiRouter.post("").setId("@rooms.update");
            apiRouter.get("").setId("@rooms.view");
            apiRouter.delete("").setId("@rooms.delete");

            apiRouter.group("/action", function (apiRouter) {
              apiRouter.post("/migrate-hotel").setId("@rooms.migrateHotel");
              apiRouter.post("/restore").setId("@rooms.restore");
              apiRouter.post("/duplicate").setId("@rooms.duplicate");
              apiRouter.get("/status").setId("@hotelsRoomsAction.status");
            });
            apiRouter.group("/availabilities", function (apiRouter) {
              // Export iCal
              apiRouter
                .post("/calendar")
                .setId("@rooms.availabilitiesCalendar");
              apiRouter.group("/remotes", function (apiRouter) {
                // iCal
                apiRouter
                  .post("")
                  .setId("@hotelsRoomsAvailabilitiesRemotes.create");
                apiRouter.group("/<remoteId>", function (apiRouter) {
                  apiRouter.setConstraint("remoteId", /\d+/);
                  apiRouter
                    .delete("")
                    .setId("@hotelsRoomsAvailabilitiesRemotes.delete");
                  apiRouter
                    .post("")
                    .setId("@hotelsRoomsAvailabilitiesRemotes.update");
                  apiRouter
                    .get("")
                    .setId("@hotelsRoomsAvailabilitiesRemotes.show");
                });
              });
              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .get("/by-dates")
                  .setId("@hotelsRoomsAvailabilitiesAction.byDates");
              });

              apiRouter.group("/partners", function (apiRouter) {
                apiRouter.group("/action", function (apiRouter) {
                  apiRouter
                    .post("/batch")
                    .setId("@hotelsRoomsAvailabilitiesPartner.batch");
                });
              });
            });

            apiRouter.group("/rankings", function (apiRouter) {
              apiRouter.post("").setId("@roomsRankings.create");
            });
          });
          apiRouter.get("").setId("@hotelsRooms.viewAny");
          apiRouter.group("/action", function (apiRouter) {
            apiRouter
              .get("/export-remote-url")
              .setId("@hotelsRooms.exportRemoteUrl");
            apiRouter.get("/export").setId("@hotelsRooms.export");

            apiRouter.group("/autocomplete", function (apiRouter) {
              apiRouter.get("").setId("@hotelsRooms.autocomplete");
            });
          });
          apiRouter.group("/availabilities", function (apiRouter) {
            apiRouter.group("/remotes", function (apiRouter) {
              // iCal
              apiRouter
                .get("")
                .setId("@hotelsRoomsAvailabilitiesRemotes.viewAny");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .get("/export")
                  .setId("@hotelsRoomsAvailabilitiesRemotes.export");
              });
            });
          });

          apiRouter.group("/services", function (apiRouter) {
            apiRouter.get("/types").setId("@roomsServices.types");
            apiRouter.get("").setId("@roomsServices.viewAny");
            apiRouter.post("").setId("@roomsServices.create");

            apiRouter.group("/<roomServiceId>", function (apiRouter) {
              apiRouter.setConstraint("roomServiceId", /\d+/);
              apiRouter.delete("").setId("@roomsServices.delete");
              apiRouter.post("").setId("@roomsServices.update");
              apiRouter.get("").setId("@roomsServices.show");

              apiRouter.group("/subscribers", function (apiRouter) {
                apiRouter.post("").setId("@roomsServices.subscribe");
              });
            });
          });

          apiRouter.group("/discounts", function (apiRouter) {
            apiRouter.get("").setId("@roomsDiscounts.viewAny");
            apiRouter.post("").setId("@roomsDiscounts.create");

            apiRouter.group("/<discountId>", function (apiRouter) {
              apiRouter.setConstraint("discountId", /\d+/);
              apiRouter.delete("").setId("@roomsDiscounts.delete");
              apiRouter.post("").setId("@roomsDiscounts.update");
              apiRouter.get("").setId("@roomsDiscounts.show");

              apiRouter.group("/subscribers", function (apiRouter) {
                apiRouter.post("").setId("@roomsDiscounts.subscribe");
              });
            });
          });

          // Documents (Pièce jointe)
          apiRouter.group("/documents", function (apiRouter) {
            apiRouter.get("").setId("@roomsDocuments.viewAny");
            apiRouter.post("").setId("@roomsDocuments.create");

            apiRouter.group("/<documentId>", function (apiRouter) {
              apiRouter.setConstraint("documentId", /\d+/);
              apiRouter.delete("").setId("@roomsDocuments.delete");
              apiRouter.post("").setId("@roomsDocuments.update");
              apiRouter.get("").setId("@roomsDocuments.show");

              apiRouter.group("/subscribers", function (apiRouter) {
                apiRouter.post("").setId("@roomsDocuments.subscribe");
              });

              apiRouter.group("/action", (apiRouter) => {
                apiRouter.post("/restore").setId("@roomsDocuments.restore");
              });
            });
          });

          // Seasons (Tarifs)
          apiRouter.group("/seasons", function (apiRouter) {
            apiRouter.get("").setId("@roomsSeasons.viewAny");
            apiRouter.post("").setId("@roomsSeasons.create");
            apiRouter.post("/duplicate").setId("@roomsSeasons.duplicate");
            apiRouter.post("/position").setId("@roomsSeasons.position");

            apiRouter.group("/<seasonId>", function (apiRouter) {
              apiRouter.setConstraint("seasonId", /\d+/);
              apiRouter.delete("").setId("@roomsSeasons.delete");
              apiRouter.post("").setId("@roomsSeasons.update");
              apiRouter.get("").setId("@roomsSeasons.show");
            });
          });

          apiRouter.group("/pictures", function (apiRouter) {
            apiRouter.group("/categories", function (apiRouter) {
              apiRouter.group("/action", function (apiRouter) {
                apiRouter
                  .get("/autocomplete")
                  .setId("@roomsPicturesCategories.autocomplete");
              });

              apiRouter.get("").setId("@roomsPicturesCategories.viewAny");

              apiRouter.group("/<pictureCategoryId>", function (apiRouter) {
                apiRouter.setConstraint("pictureCategoryId", /\d+/);

                apiRouter.delete("").setId("@roomsPicturesCategories.delete");

                apiRouter.post("").setId("@roomsPicturesCategories.update");

                apiRouter.group("/action", function (apiRouter) {
                  apiRouter
                    .post("/restore")
                    .setId("@roomsPicturesCategories.restore");
                });
              });
            });

            apiRouter.group("/action", function (apiRouter) {
              apiRouter.post("/batch").setId("@hotels.pictures.batch");
            });
          });
        });
      });

      // Tourist tax
      apiRouter.group("/tourist-tax", function (apiRouter) {
        // deliberations
        apiRouter.group("/deliberations", function (apiRouter) {
          apiRouter.get("").setId("@touristTaxDeliberations.viewAny");
          apiRouter.group("/<deliberationId>", function (apiRouter) {
            apiRouter.setConstraint("deliberationId", /\d+/);
            apiRouter.get("").setId("@touristTaxDeliberations.view");
            apiRouter.post("").setId("@touristTaxDeliberations.update");
          });
        });
      });

      // Notifications
      apiRouter.group("/notifications", function (apiRouter) {
        apiRouter.get("").setId("@notifications.viewAny");
      });

      // years
      apiRouter.group("/years", (apiRouter) => {
        apiRouter.get("").setId("@years.viewAny");
      });

      // Payments
      apiRouter.group("/payments", function (apiRouter) {
        apiRouter.get("").setId("@payments.viewAny");
        apiRouter.group("/action", (apiRouter) => {
          apiRouter.get("/export").setId("@payments.export");
        });
        apiRouter.group("/<paymentId>", (apiRouter) => {
          apiRouter.setConstraint("paymentId", /\d+/);
          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/sold").setId("@payments.sold");
            apiRouter.post("/cancel").setId("@payments.cancel");
          });
        });

        // remittances
        apiRouter.group("/remittances", function (apiRouter) {
          apiRouter.get("").setId("@paymentsRemittances.viewAny");
          apiRouter.post("").setId("@paymentsRemittances.create");
          apiRouter.group("/<remittanceId>", (apiRouter) => {
            apiRouter.setConstraint("remittanceId", /\d+/);
            apiRouter.get("").setId("@paymentsRemittances.view");
            apiRouter.post("").setId("@paymentsRemittances.update");
          });
        });

        // sepas
        apiRouter.group("/sepas", (apiRouter) => {
          apiRouter.get("").setId("@paymentsSepas.viewAny");
          apiRouter.group("/action", (apiRouter) => {
            apiRouter.get("/export").setId("@paymentsSepas.export");
          });
          apiRouter.group("/<sepaId>", (apiRouter) => {
            apiRouter.setConstraint("sepaId", /\d+/);
            apiRouter.post("").setId("@paymentsSepas.view");

            apiRouter.group("/transactions", (apiRouter) => {
              apiRouter.get("").setId("@paymentsSepasTransactions.viewAny");
              apiRouter.group("/<transactionId>", (apiRouter) => {
                apiRouter.setConstraint("transactionId", /\d+/);
                apiRouter.group("/action/export", (apiRouter) => {
                  apiRouter.get("").setId("@paymentsSepasTransactions.export");
                });
              });
            });

            apiRouter.group("/action", (apiRouter) => {
              apiRouter.get("/finish").setId("@paymentsSepas.finish");
              apiRouter.group("/download", (apiRouter) => {
                apiRouter.group("/<filename>", (apiRouter) => {
                  apiRouter.setConstraint("filename", /\d+/);
                  apiRouter.get("").setId("@paymentsSepas.download");
                });
              });
              apiRouter.group("/download-export", (apiRouter) => {
                apiRouter.group("/<filename>", (apiRouter) => {
                  apiRouter.setConstraint("filename", /\d+/);
                  apiRouter.get("").setId("@paymentsSepas.downloadExport");
                });
              });
            });
          });
        });
      });

      // partners
      apiRouter.group("/partners", (apiRouter) => {
        apiRouter.get("").setId("@partners.viewAny");
        apiRouter.post("").setId("@partners.create");
        apiRouter.group("/<partnerId>", function (apiRouter) {
          apiRouter.setConstraint("partnerId", /\d+/);
          apiRouter.post("").setId("@partners.update");
          apiRouter.get("").setId("@partners.show");
          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/attach").setId("@partners.attach");
            apiRouter.post("/detach").setId("@partners.detach");
          });
        });
        apiRouter.group("/logs", function (apiRouter) {
          apiRouter.get("").setId("@api.partners.viewAny");
          apiRouter.group("/<logId>", (apiRouter) => {
            apiRouter.setConstraint("logId", /\d+/);
            apiRouter.get("").setId("@api.partners.logs.show");
          });
        });
      });

      // subscriptions
      apiRouter.group("/subscriptions", (apiRouter) => {
        apiRouter.get("").setId("@subscriptions.viewAny");
        apiRouter.post("").setId("@subscriptions.create");
        apiRouter.group("/<subscriptionId>", function (apiRouter) {
          apiRouter.setConstraint("subscriptionId", /\d+/);
          apiRouter.get("").setId("@subscriptions.view");
          apiRouter.post("").setId("@subscriptions.update");
          apiRouter.group("/customers", function (apiRouter) {
            apiRouter.get("").setId("@subscriptionsCustomers.create");
          });
        });
        apiRouter.group("/customers", function (apiRouter) {
          apiRouter.get("").setId("@subscriptionsCustomers.viewAny");
          apiRouter.group("/<subscriptionCustomerId>", function (apiRouter) {
            apiRouter.setConstraint("subscriptionCustomerId", /\d+/);
            apiRouter.get("").setId("@subscriptionsCustomers.view");
            apiRouter.group("/action", function (apiRouter) {
              apiRouter
                .get("/batch")
                .setId("@subscriptionsCustomers.batchRooms");
              apiRouter.get("/cancel").setId("@subscriptionsCustomers.cancel");
            });
          });
          apiRouter.group("/action", function (apiRouter) {
            apiRouter.get("/export").setId("@subscriptionsCustomers.export");
          });
        });
      });

      // metrics
      apiRouter.group("/metrics", (apiRouter) => {
        apiRouter.get("").setId("@metrics.viewAny");
      });

      // invoices
      apiRouter.group("/invoices", (apiRouter) => {
        apiRouter.get("").setId("@invoices.viewAny");
        apiRouter.group("/<invoiceId>", function (apiRouter) {
          apiRouter.setConstraint("invoiceId", /\d+/);
          apiRouter.group("/action", function (apiRouter) {
            apiRouter.get("/download").setId("@invoices.download");
          });
        });

        apiRouter.group("/action", function (apiRouter) {
          apiRouter.get("/export").setId("@invoices.export");
          apiRouter.get("/download-batch").setId("@invoices.downloadBatch");
        });
      });

      // insurances
      apiRouter.group("/insurances", (apiRouter) => {
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.get("/autocomplete").setId("@insurances.autocomplete");
        });
        apiRouter.group("/contracts", (apiRouter) => {
          apiRouter.get("").setId("@insurances.viewAny");
          apiRouter.group("/exports", (apiRouter) => {
            apiRouter.get("").setId("@insurances.export");
            apiRouter.group("/<exportId>", (apiRouter) => {
              apiRouter.setConstraint("exportId", /\d+/);
              apiRouter
                .get("/action/download")
                .setId("@insurances.exportDownload");
            });
          });
        });
      });

      // rentals
      apiRouter.group("/rentals", (apiRouter) => {
        apiRouter.group("/logs", (apiRouter) => {
          apiRouter.get("").setId("@rentalsLogs.viewAny");
          apiRouter.group("/<logId>", function (apiRouter) {
            apiRouter.setConstraint("logId", /\d+/);
            apiRouter.get("").setId("@rentalsLogs.show");
          });
        });
      });

      // slideshows
      apiRouter.group("/slideshows", (apiRouter) => {
        apiRouter.get("").setId("@slideshows.viewAny");
        apiRouter.group("/<slideshowId>", function (apiRouter) {
          apiRouter.setConstraint("slideshowId", /\d+/);
          apiRouter.get("").setId("@slideshows.show");
          apiRouter.post("").setId("@slideshows.delete");
          apiRouter.post("").setId("@slideshows.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@slideshows.restore");
          });

          apiRouter.group("/items", function (apiRouter) {
            apiRouter.get("").setId("@slideshowsItems.viewAny");
            apiRouter.post("").setId("@slideshowsItems.create");

            apiRouter.group("/<slideshowItemId>", function (apiRouter) {
              apiRouter.setConstraint("slideshowItemId", /\d+/);
              apiRouter.get("").setId("@slideshowsItems.show");
              apiRouter.post("").setId("@slideshowsItems.update");
              apiRouter.post("").setId("@slideshowsItems.delete");

              apiRouter.group("/action", function (apiRouter) {
                apiRouter.post("/restore").setId("@slideshowsItems.restore");
              });
            });
          });
        });
      });

      // Campaigns
      apiRouter.group("/campaigns", function (apiRouter) {
        apiRouter.get("").setId("@campaigns.viewAny");

        apiRouter.post("").setId("@campaigns.create");

        apiRouter.group("/<campaignId>", function (apiRouter) {
          apiRouter.setConstraint("campaignId", /\d+/);

          apiRouter.get("").setId("@campaigns.show");

          apiRouter.post("").setId("@campaigns.update");

          apiRouter.delete("").setId("@campaigns.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/restore").setId("@campaigns.restore");
          });
        });

        // Campaigns/Categories
        apiRouter.group("/categories", function (apiRouter) {
          apiRouter.get("").setId("@campaignsCategories.viewAny");

          apiRouter.post("").setId("@campaignsCategories.create");

          apiRouter.group("/<campaignsCategoryId>", function (apiRouter) {
            apiRouter.setConstraint("campaignsCategoryId", /\d+/);

            apiRouter.get("").setId("@campaignsCategories.show");

            apiRouter.post("").setId("@campaignsCategories.update");

            apiRouter.post("").setId("@campaignsCategories.delete");

            apiRouter.group("/action", function (apiRouter) {
              apiRouter
                .get("/autocomplete")
                .setId("@campaignsCategories.autocomplete");
              apiRouter.group("/restore", function (apiRouter) {
                apiRouter.post("").setId("@campaignsCategories.restore");
              });
            });
          });
        });
      });
      // Highlights
      apiRouter.group("/highlights", function (apiRouter) {
        apiRouter.get("").setId("@highlights.viewAny");

        apiRouter.group("/<highlightId>", function (apiRouter) {
          apiRouter.setConstraint("highlightId", /\d+/);

          apiRouter.get("").setId("@highlights.view");

          apiRouter.group("/hotels", function (apiRouter) {
            apiRouter.get("").setId("@highlights.hotels.create");
          });
        });
        apiRouter.group("/hotels", function (apiRouter) {
          apiRouter.group("/<hotelHighlightId>", function (apiRouter) {
            apiRouter.setConstraint("hotelHighlightId", /\d+/);

            apiRouter.group("/action", function (apiRouter) {
              apiRouter.post("/review").setId("@highlights.hotels.review");
            });
            apiRouter.delete("").setId("@highlights.hotels.delete");
          });
        });
      });

      apiRouter.group("/ota", function (apiRouter) {
        apiRouter.group("/types", function (apiRouter) {
          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/autocomplete").setId("@otaTypes.autocomplete");
          });
        });
      });

      // Plans
      apiRouter.group("/plans", function (apiRouter) {
        apiRouter.get("").setId("@plans.viewAny");

        apiRouter.post("").setId("@plans.create");

        apiRouter.group("/<planId>", function (apiRouter) {
          apiRouter.setConstraint("planId", /\d+/);

          apiRouter.get("").setId("@plans.view");

          apiRouter.post("").setId("@plans.update");

          apiRouter.delete("").setId("@plans.delete");

          apiRouter.group("/action", function (apiRouter) {
            apiRouter.post("/autocomplete").setId("@plans.autocomplete");
          });
        });
      });

      // Search
      apiRouter.group("/search", function (apiRouter) {
        apiRouter.get("/hotels").setId("@search.hotels");
      });

      // Tasks
      apiRouter.group("/tasks", (apiRouter) => {
        apiRouter.get("").setId("@api.tasks.viewAny");

        apiRouter.group("/<taskId>", (apiRouter) => {
          apiRouter.setConstraint("taskId", /\d+/);

          apiRouter.get("").setId("@api.tasks.view");

          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/retry").setId("@api.tasks.retry");
            apiRouter.post("/cancel").setId("@api.tasks.cancel");
          });
        });
      });

      // Newsgroups
      apiRouter.group("/newsgroups", (apiRouter) => {
        apiRouter.get("").setId("@api.newsgroups.viewAny");
        apiRouter.post("").setId("@api.newsgroups.create");

        apiRouter.group("/action", (apiRouter) => {
          apiRouter.get("/autocomplete").setId("@api.newsgroups.autocomplete");
        });

        apiRouter.group("/<newsgroupId>", (apiRouter) => {
          apiRouter.setConstraint("newsgroupId", /\d+/);
          apiRouter.get("").setId("@api.newsgroups.view");
          apiRouter.post("").setId("@api.newsgroups.update");
          apiRouter.post("").setId("@api.newsgroups.delete");

          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/restore").setId("@api.newsgroups.restore");
          });
        });

        // Newsgroups/Subscribers
        apiRouter.group("/subscribers", (apiRouter) => {
          apiRouter.get("").setId("@api.newsgroups.subscribers.viewAny");
          apiRouter.post("").setId("@api.newsgroups.subscribers.create");

          apiRouter.group("/action", (apiRouter) => {
            apiRouter
              .get("/autocomplete")
              .setId("@api.newsgroups.subscribers.autocomplete");
            apiRouter
              .get("/export")
              .setId("@api.newsgroups.subscribers.export");
          });

          apiRouter.group("/<newsgroupSubscriberId>", (apiRouter) => {
            apiRouter.setConstraint("newsgroupSubscriberId", /\d+/);
            apiRouter.get("").setId("@api.newsgroups.subscribers.view");
            apiRouter.post("").setId("@api.newsgroups.subscribers.update");
            apiRouter.post("").setId("@api.newsgroups.subscribers.delete");

            apiRouter.group("/action", (apiRouter) => {
              apiRouter
                .post("/enable")
                .setId("@api.newsgroups.subscribers.enable");
            });
          });
        });
      });

      // CustomLocations
      apiRouter.group("/custom-locations", (apiRouter) => {
        apiRouter.get("").setId("@api.custom_locations.viewAny");
        apiRouter.post("").setId("@api.custom_locations.create");

        apiRouter.group("/<customLocationId>", (apiRouter) => {
          apiRouter.setConstraint("customLocationId", /\d+/);
          apiRouter.get("").setId("@api.custom_locations.view");
          apiRouter.post("").setId("@api.custom_locations.update");
          apiRouter.delete("").setId("@api.custom_locations.delete");

          apiRouter.group("/action", (apiRouter) => {
            apiRouter.post("/restore").setId("@api.custom_locations.restore");
          });
        });
      });
    });

    // saml
    apiRouter.group("/saml", (apiRouter) => {
      apiRouter.group("/sso", (apiRouter) => {
        apiRouter.get("").setId("@samlSso.view");
      });
    });

    apiRouter.group("/auth", function (apiRouter) {
      apiRouter.post("/login").setId("@auth.login");

      apiRouter.post("/me").setId("@auth.me");

      apiRouter.post("/logout").setId("@auth.logout");
    });

    apiRouter.group("/sanctum", function (apiRouter) {
      apiRouter.group("/csrf-cookie", function (apiRouter) {
        apiRouter.get("").setId("@sanctum.csrfCookie");
      });
    });

    apiRouter.group("/laravel", function (apiRouter) {
      apiRouter.get("/telescope").setId("@laravel.telescope");

      apiRouter.get("/horizon").setId("@laravel.horizon");
    });

    // Places
    apiRouter.group("/places", function (apiRouter) {
      apiRouter.group("/<placeId>", function (apiRouter) {
        apiRouter.setConstraint("placeId", /\d+/);
        apiRouter.get("").setId("@places.show");
      });
      apiRouter.group("/action", function (apiRouter) {
        apiRouter.get("/autocomplete").setId("@places.autocomplete");
      });
    });

    // Leads
    apiRouter.group("/leads", function (apiRouter) {
      apiRouter.post("").setId("@leads.create");
    });

    // Hotels
    apiRouter.group("/hotels", function (apiRouter) {
      apiRouter.group("/<hotelId>", function (apiRouter) {
        apiRouter.setConstraint("hotelId", /\d+/);
        apiRouter.group("/action", function (apiRouter) {
          apiRouter.group("/contact", function (apiRouter) {
            apiRouter.post("").setId("@hotelcontacts.create");
          });
        });
      });
    });
  },
);

export default apiRouter;
